export default __webpack_public_path__ + "static/media/wu.f366831a.png";